import { render } from "./uploadDailog.vue?vue&type=template&id=0c4883f4&scoped=true"
import script from "./uploadDailog.vue?vue&type=script&lang=js"
export * from "./uploadDailog.vue?vue&type=script&lang=js"

import "./uploadDailog.vue?vue&type=style&index=0&id=0c4883f4&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4883f4"]])

export default __exports__